import { Link } from "react-router-dom";
import { eur, img } from "@/lib/api";
import { LogoMark } from "@/components/Logo";

export const ProductImage = ({ image, className = "" }) =>
  image ? (
    <img src={img(image.url)} alt={image.alt || ""} loading="lazy" className={`h-full w-full object-contain ${className}`} />
  ) : (
    <div className="flex h-full w-full items-center justify-center bg-slate-50"><LogoMark className="h-14 w-14 opacity-30" /></div>
  );

export const ProductCard = ({ p, index = 0 }) => (
  <Link to={`/prodotto/${p.slug}`} data-testid={`product-card-${p.slug}`} style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }}
    className="lt-rise group flex flex-col overflow-hidden rounded-3xl border border-slate-200 bg-white transition-[transform,box-shadow,border-color] duration-300 hover:-translate-y-1 hover:border-[#0066FF]/40 hover:shadow-[0_24px_50px_-24px_rgba(0,102,255,0.45)]">
    <div className="relative aspect-square overflow-hidden bg-white">
      <ProductImage image={p.images?.[0]} className="p-5 transition-transform duration-500 group-hover:scale-105" />
      {p.ribbon && (
        <span className="absolute left-3 top-3 max-w-[calc(100%-5rem)] truncate rounded-full bg-[#0A0B0E] px-2.5 py-1 text-[10px] font-semibold uppercase tracking-wider text-white">{p.ribbon}</span>
      )}
      {p.discount_pct > 0 && (
        <span className="absolute right-3 top-3 rounded-full bg-[#0066FF] px-2 py-1 text-[11px] font-bold text-white">-{p.discount_pct}%</span>
      )}
    </div>
    <div className="flex flex-1 flex-col gap-1.5 border-t border-slate-100 p-4">
      {p.category_path && <span className="truncate text-[10px] font-semibold uppercase tracking-[0.18em] text-slate-400">{p.category_path.split(" / ").pop()}</span>}
      <h3 className="line-clamp-2 font-display text-[15px] font-semibold leading-snug text-[#0A0B0E]">{p.name}</h3>
      <div className="mt-auto flex items-baseline gap-2 pt-2">
        <span className="font-display text-lg font-bold text-[#0A0B0E]" data-testid={`product-card-price-${p.slug}`}>{eur(p.price)}</span>
        {p.compare_price > p.price && <span className="text-xs text-slate-400 line-through">{eur(p.compare_price)}</span>}
      </div>
    </div>
  </Link>
);

export const ProductGrid = ({ items, loading, testid = "product-grid" }) => (
  <div className="grid grid-cols-2 gap-3 sm:gap-5 md:grid-cols-3 xl:grid-cols-4" data-testid={testid}>
    {loading
      ? Array.from({ length: 4 }).map((_, i) => <div key={i} className="aspect-[3/4] animate-pulse rounded-3xl bg-slate-100" />)
      : items.map((p, i) => <ProductCard key={p.id} p={p} index={i} />)}
  </div>
);
